import styled from '@emotion/styled';
import { css } from '@emotion/react';

interface ILabelledArrowProps {
    backgroundColor: string;
    heightBox: number;
    leftTriangle: boolean | undefined;
    rightTriangle: boolean | undefined;
}

export const StyledTriangledArrow = styled.div<ILabelledArrowProps>`
    background: ${(props) => props.backgroundColor};
    position: relative;
    height: ${(props) => props.heightBox}px;
    display: flex;
    align-items: center;
    &:before,
    &:after {
        content: '';
        z-index: 9;
        position: absolute;
        top: 0;
    }

    ${(props) =>
        props.leftTriangle
            ? css`
                  &::before {
                      width: 0;
                      height: 0;
                      border-style: solid;
                      border-width: ${props.heightBox / 2}px ${Math.floor(props.heightBox / 3)}px
                          ${props.heightBox / 2}px 0;
                      border-color: transparent ${props.backgroundColor} transparent transparent;
                      left: -${Math.floor(props.heightBox / 3)}px;
                  }
              `
            : ``}
    ${(props) =>
        props.rightTriangle
            ? css`
                  &::after {
                      width: 0;
                      height: 0;
                      border-style: solid;
                      border-width: ${props.heightBox / 2}px 0 ${props.heightBox / 2}px
                          ${Math.floor(props.heightBox / 3)}px;
                      border-color: transparent transparent transparent ${props.backgroundColor};
                      right: -${Math.floor(props.heightBox / 3)}px;
                  }
              `
            : ``}
`;
